import { render, staticRenderFns } from "./ComGoodsGroup.vue?vue&type=template&id=6a364c5b&scoped=true&"
import script from "./ComGoodsGroup.vue?vue&type=script&lang=js&"
export * from "./ComGoodsGroup.vue?vue&type=script&lang=js&"
import style0 from "./ComGoodsGroup.vue?vue&type=style&index=0&id=6a364c5b&prod&lang=css&"
import style1 from "./ComGoodsGroup.vue?vue&type=style&index=1&id=6a364c5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a364c5b",
  null
  
)

export default component.exports